const ENV = process.env.NODE_ENV

export const BJ_URL =
  ENV === 'development'
    ? '//test-zt-xsjsy.xoyo.com'
    : '//zt-xsjsy.xoyo.com'
export const BJ_URL_JY = '//zt-xsjsy.xoyo.com/core/captcha/pre_auth'
